import { renderToStaticMarkup } from "react-dom/server";
import HtmlEnrollmentDocument from "./HtmlEnrollmentDocument";
import { V2_DOCUMENTS, V2_ENROLLMENT_YEAR } from "./documentV2Config";

// Print the same React tree as the preview: text and borders stay sharp in the PDF.
export async function printDocumentV2(documentType, values = {}) {
  const frame = document.createElement("iframe");
  frame.title = "Impresión del documento de inscripción";
  frame.style.cssText = "position:fixed;left:-10000px;top:0;width:794px;height:1123px;border:0";
  const styles = [...document.querySelectorAll('style, link[rel="stylesheet"]')]
    .map((node) => node.outerHTML)
    .join("\n");
  const markup = renderToStaticMarkup(
    documentType === "complete" ? (
      <div className="react-document-bundle">
        <HtmlEnrollmentDocument documentType="solicitud" values={values.solicitud} />
        <HtmlEnrollmentDocument documentType="anexo" values={values.anexo} />
      </div>
    ) : (
      <HtmlEnrollmentDocument documentType={documentType} values={values} />
    )
  );
  const title = `${
    documentType === "complete" ? "Documentación completa" : V2_DOCUMENTS[documentType].heading
  } ${V2_ENROLLMENT_YEAR}`;
  try {
    await new Promise((resolve, reject) => {
      frame.onload = resolve;
      frame.onerror = () => reject(new Error("No se pudo preparar el documento para imprimir."));
      frame.srcdoc = `<!doctype html><html lang="es"><head><meta charset="utf-8"><base href="${window.location.origin}/"><title>${title}</title>${styles}</head><body>${markup}</body></html>`;
      document.body.appendChild(frame);
    });
    await frame.contentDocument.fonts?.ready;
    await Promise.all(
      [...frame.contentDocument.images].map((img) =>
        img.decode ? img.decode() : Promise.resolve()
      )
    );
    frame.contentWindow.addEventListener("afterprint", () => frame.remove(), { once: true });
    frame.contentWindow.focus();
    frame.contentWindow.print();
    // Some browsers do not dispatch afterprint for iframe documents.
    window.setTimeout(() => frame.remove(), 300000);
  } catch (error) {
    frame.remove();
    throw error;
  }
}

export function PreviewDocumentV2({ documentType, values }) {
  return <HtmlEnrollmentDocument documentType={documentType} values={values} />;
}
